import type { DashboardCapabilityContext, DashboardRoleBucket } from "./types";
import { CONCEPT_ADMIN_ROLE_CODES } from "@/lib/access-control/concept-admin";

export const INTERNAL_ROLE_CODES = ["SUPER_ADMIN", "SUPPORT"] as const;
export const ORG_ADMIN_ROLE_CODES = ["ORG_ADMIN", ...CONCEPT_ADMIN_ROLE_CODES] as const;
export const MANAGER_ROLE_CODES = [
  "REGION_MANAGER",
  "STATE_MANAGER",
  "CITY_MANAGER",
  "LOCATION_MANAGER",
] as const;

function hasAnyRole(check: DashboardCapabilityContext["hasRole"], roles: readonly string[]) {
  return roles.some((role) => check(role));
}

export function resolveDashboardRoleBucket(context: DashboardCapabilityContext): DashboardRoleBucket {
  if (hasAnyRole(context.hasRole, INTERNAL_ROLE_CODES)) {
    return "SUPPORT";
  }

  if (hasAnyRole(context.hasRole, ORG_ADMIN_ROLE_CODES)) {
    return "ORG_ADMIN";
  }

  if (hasAnyRole(context.hasRole, MANAGER_ROLE_CODES)) {
    return "MANAGER";
  }

  return "CHEF";
}

export function isSupportUser(context: DashboardCapabilityContext): boolean {
  return context.hasRole("SUPPORT");
}
